import React, { FC, useState } from 'react'
import {
  ComparisonItem,
  Div,
  Spacer,
  Text,
} from '@sendoutcards/quantum-design-ui'
import { PromptingsLogo497SVG } from './PromptingsLogoSVG'
import { Button } from 'src/design_system/components/Button'
import { UpsaleBackground } from './constants'
import { PromptingsPackageUpsaleModal } from './PromptingsPackageUpsaleModal'
import { Portal } from '../portal/portal'

const styles = {
  desktopGrid: {
    display: 'grid',
    gridTemplateColumns: 'minmax(300px, 500px) max(400px)',
    gridTemplateAreas: `
    "header header"
    "features image"
    "features actions"
    `,
    columnGap: 'max(50px, 5vw)',
    justifyContent: 'center',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    '@media (max-width: 1000px)': {
      gridTemplateColumns: '60% 40%',
    },
    '@media (max-width: 850px)': {
      gridTemplateColumns: '100%',
      gridTemplateAreas: `
        "header"
        "image"
        "features"
        "actions"
      `,
    },
  },
  header: {
    gridArea: 'header',
  },
  features: {
    gridArea: 'features',
    '@media (max-width: 850px)': {
      justifySelf: 'center',
    },
  },
  image: {
    gridArea: 'image',
    alignSelf: 'center',
    justifySelf: 'center',
    width: 'min(100%, 360px)',
    '@media (max-width: 850px)': {
      width: '60%',
      marginBottom: '2rem',
    },
    '@media (max-width: 576px)': {
      width: '90%',
    },
  },
  actions: {
    gridArea: 'actions',
    '@media (max-width: 1200px)': {
      flexDirection: 'column' as const,
      rowGap: '1rem',
      justifySelf: 'center',
      alignItems: 'center',
    },
    '@media (max-width: 850px)': {
      marginTop: '2rem',
      flexDirection: 'row' as const,
    },
    '@media (max-width: 400px)': {
      flexDirection: 'column' as const,
    },
  },
}

type PromptingsPackageUpsaleProps = {
  sponsorId?: string
  isMobile?: boolean
}

export const PromptingsPackageUpsale: FC<PromptingsPackageUpsaleProps> = ({
  sponsorId,
  isMobile,
}) => {
  const features = [
    {
      title: 'Unlimited Heartfelt Prompting Cards',
      description: 'With contact manager.',
    },
    {
      title: '100 System Cards',
      description: '',
    },
    {
      title: 'Campaign Store',
      description: 'Featuring Custom Built Cards & Campaigns',
    },
    {
      title: 'Virtual Assistant',
      description: '',
    },
    {
      title: 'Premier Gift Sending',
      description: 'Lowest delivered pricing',
    },
    {
      title: 'Relationship Marketing online training course',
      description: '',
    },
    {
      title: 'Promptings Personal Coach',
      description: '',
    },
    {
      title: 'Level 1 training: Promptings Seminar',
      description: '',
    },
  ]

  const [shouldDisplayModal, setShouldDisplayModal] = useState(false)

  const handleOnGetStarted = async () => {
    setShouldDisplayModal(true)
  }
  const handleOnMoreInfo = () => {
    window.open('https://www.promptingsprocesspackage.com/', '_blank')
  }

  const onModalClose = () => {
    setShouldDisplayModal(false)
  }

  const standardButtonProps = {
    textSize: '0.8125rem',
    textWeight: 700,
    width: '160px',
    padding: '1rem',
  }

  return (
    <>
      {shouldDisplayModal && (
        <Portal>
          <PromptingsPackageUpsaleModal
            sponsorId={sponsorId}
            onBlankAreaClick={onModalClose}
            isMobile={isMobile}
          />
        </Portal>
      )}
      <Div
        width="100%"
        css={styles.desktopGrid}
        backgroundImage={`data:image/png;base64, ${UpsaleBackground}`}
        inset="x6"
      >
        <Div css={styles.header}>
          <Text
            type="title"
            content="OR BUNDLE AND SAVE WITH"
            alignment="center"
            weight="extraBold"
            color="accent"
          />
          <Spacer space="x6" />
        </Div>
        <Div
          inset="x4"
          borderRadius="medium"
          backgroundColor="foreground"
          maxWidth="500px"
          css={styles.features}
        >
          <Text
            type="largeBody"
            weight="bold"
            content="Package Includes"
            color="primaryHeading"
          />
          <Spacer space="x4" />
          <Div display="grid" rowGap="1.25em">
            {features.map(feature => (
              <ComparisonItem
                key={feature.title}
                title={feature.title}
                description={feature.description}
                isIncluded={true}
              />
            ))}
          </Div>
        </Div>
        <Div css={styles.image} position="relative">
          <PromptingsLogo497SVG />
        </Div>
        <Div
          css={styles.actions}
          display="flex"
          columnGap="x2"
          justifyContent="center"
        >
          <Button
            {...standardButtonProps}
            title="GET STARTED"
            onClick={handleOnGetStarted}
            backgroundColor="#5D4FAA"
          />
          <Button
            {...standardButtonProps}
            title="MORE INFO"
            onClick={handleOnMoreInfo}
            backgroundColor="white"
            textColor="#242424"
          />
        </Div>
      </Div>
    </>
  )
}
